"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Terminal, Cpu, Database, Network } from "lucide-react";
const faqData = [{
  question: "How often should I schedule lawn mowing and maintenance?",
  answer: "For most residential properties in our area, we recommend weekly mowing during the peak growing season. This ensures your grass stays at an optimal height for root health and prevents weed encroachment, maintaining that lush, manicured look year-round.",
  linkText: "View Maintenance Plans",
  linkUrl: "/SeasonalCarePage",
  icon: Database
}, {
  question: "What is the best time of year for new sod installation?",
  answer: "While sod can be installed throughout the growing season, early spring and early fall are ideal. These periods offer cooler temperatures and more natural rainfall, which helps the root system establish quickly without the stress of extreme summer heat.",
  linkText: "Explore Sod Services",
  linkUrl: "/OurCraftPage",
  icon: Network
}, {
  question: "Do you provide custom landscape design for small backyards?",
  answer: "Absolutely. Our design team specializes in maximizing utility and beauty in spaces of all sizes. We use architectural principles to create custom patios and planting schemes that make even the most compact yards feel like a private sanctuary.",
  linkText: "See Design Portfolio",
  linkUrl: "/OurCraftPage",
  icon: Cpu
}, {
  question: "How do you handle irrigation system repairs and winterization?",
  answer: "We provide full-service irrigation support, from fixing broken heads and leaks to seasonal blowouts. Proper winterization is critical to prevent pipe bursts, and our team ensures your system is fully protected before the first frost.",
  linkText: "Schedule Irrigation Service",
  linkUrl: "/GetAQuotePage",
  icon: Terminal
}];
export default function Faq() {
  return <section data-section-id="223794" id="common-questions" className="bg-background text-foreground relative min-h-screen py-32 px-6 md:px-12 lg:px-24 overflow-hidden flex flex-col justify-center">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary/30 to-transparent" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-primary/30 to-transparent" />
        <div className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary/10 to-transparent" />
      </div>

      <div className="max-w-4xl mx-auto w-full relative z-10">
        <div className="mb-16 md:mb-24">
          <div className="inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-md border border-primary/20 bg-primary/5 backdrop-blur-sm">
            <Terminal className="size-4 text-primary" />
            <span className="text-xs font-mono text-primary uppercase tracking-widest">
              Expert Guidance
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-6 text-primary">
            Common <span className="italic font-normal">Questions</span>
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 font-default max-w-2xl leading-relaxed">
            Everything you need to know about our premium landscaping services, from seasonal maintenance to custom architectural designs.
          </p>
        </div>

        <div className="bg-card border border-border/50 rounded-2xl p-6 md:p-10 shadow-xl shadow-primary/5">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, i) => {
            const Icon = faq.icon;
            return <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40 py-2">
                  <AccordionTrigger className="text-left text-lg md:text-xl font-default font-semibold hover:text-primary transition-colors group py-6">
                    <div className="flex items-center gap-4">
                      <div className="p-2 rounded-md bg-accent text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                        <Icon className="size-5" />
                      </div>
                      <span>{faq.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-foreground/70 font-default leading-relaxed pb-8 pl-14 md:pl-16">
                    <p className="mb-6 text-base">{faq.answer}</p>
                    <Button asChild variant="link" className="p-0 h-auto text-primary hover:text-primary-foreground hover:bg-primary px-4 py-2 rounded-md transition-all font-default text-sm border border-primary/20">
                      <Link to={faq.linkUrl}>
                        {faq.linkText} <span className="ml-2">→</span>
                      </Link>
                    </Button>
                  </AccordionContent>
                </AccordionItem>;
          })}
          </Accordion>
        </div>
      </div>
    </section>;
}